import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
        padding: '0'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

interface IPhotoCriteriaDialogProps {
    setConditionsSeen: () => void;
    dialogOpen: boolean;
}

interface IPhotoCriteriaDialogState {
}

export class PhotoCriteriaDialog extends Component<IPhotoCriteriaDialogProps & WithStyles<typeof styles>, IPhotoCriteriaDialogState> {
    constructor(props) {
        super(props);

        this.state = {
        }
    }


    public render() {
        return (
            <Dialog open={this.props.dialogOpen} fullWidth={true} maxWidth={"sm"}>
                <DialogTitle>
                    Student Photo Criteria
                    <IconButton aria-label="close" className={this.props.classes.closeButton} onClick={this.props.setConditionsSeen}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        <b>Our Requirements</b>
                    </Typography>
                    <Typography>
                        To ensure that the photograph you submit online is acceptable, please make sure that it meets the following requirements:
                    </Typography>
                    <Typography>
                        The photograph must be:
                    </Typography>
                    <ul>
                        <li>Recent</li>
                        <li>In colour</li>
                        <li>Of your full head, facing forward</li>
                        <li>Without hat/cap, glasses or head covering (unless worn for religious belief or medical reasons)</li>
                        <li>Taken against a light background</li>
                    </ul>
                    <Typography>
                        Some examples of acceptable and unacceptable photographs can be seen in a pdf file available from the <a target="blank" href="https://www.gov.uk/government/publications/passport-photographs">Passport Office website (opens in new window)</a>.
                    </Typography>
                    <Typography>
                        <b>Further examples of unacceptable photographs</b>
                    </Typography>
                    <Typography>
                        It is likely that these photographs would be rejected for the reasons stated:
                    </Typography>
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <b>Face too small</b>
                                </Grid>
                                <Grid item xs={3}>
                                    <b>Face too close</b>
                                </Grid>
                                <Grid item xs={3}>
                                    <b>Background too busy</b>
                                </Grid>
                                <Grid item xs={3}>
                                    <b>Too much facial expression</b>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <img src="/PhotoCriteria/small.jpg" width={90} height={100} />
                                </Grid>
                                <Grid item xs={3}>
                                    <img src="/PhotoCriteria/close.jpg" width={90} height={100}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <img src="/PhotoCriteria/busy.jpg" width={90} height={100} />
                                </Grid>
                                <Grid item xs={3}>
                                    <img src="/PhotoCriteria/facial.jpg" width={90} height={100} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Typography>
                        <b>Please Note:</b> If you upload and submit a photograph which does not meet our requirements, you will be charged for a replacement UWE ID Card.
                    </Typography>
                </DialogContent>
            </Dialog>
        );
    }
}

export default withStyles(styles)(PhotoCriteriaDialog);

